import MsoStudentForm from './src/main'

MsoStudentForm.install = function(Vue){
  Vue.component(MsoStudentForm.name, MsoStudentForm)
}
export default MsoStudentForm